module.exports = __webpack_public_path__ + "static/media/Tata2.05c49e44.jpg";